import React, { Component } from "react";
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from "react-stripe-elements";
import PaymentFormViewProps from "./PaymentFormViewProps";
import StripeInputWrapperView from "./components/StripeInputWrapper/StripeInputWrapperView";
import PaymentFormViewStyle from "./PaymentFormViewStyle";
import TranslationView from "../../../../../../components/Translation/TranslationView";
import PriceBreakdownView from "../PriceBreakdown/PriceBreakdownView";
import FontWeight from "../../../../../../../models/constants/FontWeight";
import RadioButtonView from "../RadioButton/RadioButtonView";
import PaginatedDialogFooterView from "../../../../components/PaginatedDialog/components/PaginatedDialogFooter/PaginatedDialogFooterView";
import Service from "../../../../../../../network/Service";
import PaymentFormViewState from './PaymentFormViewState';

class PaymentFormView extends Component<PaymentFormViewProps, PaymentFormViewState> {
    private static TVA_PERCENTAGE = 0.21;

    state = { agreedToTerms: false };

    private _style = new PaymentFormViewStyle();

    private _calculateCheckTotal = () => {
        const { amount } = this.props;

        const tva = amount * PaymentFormView.TVA_PERCENTAGE;
        return [amount, tva, amount + tva];
    }

    private _onLicenseAgreementClick = (agreedToTerms: boolean) => {
        this.setState({ agreedToTerms });
    }

    private _onPaymentDetailsEntered = async (done: () => void) => {
        if (!this.state.agreedToTerms) {
            alert('Please accept our terms and conditions.')
            done();
            return;
        }

        const response = await Service.createPaymentIntentForAmount(this.props.amount, this.props.routeProps.location.state);

        if (response.error) {
            alert('Problem with payment, please contact Medicheck.')
            done();
            return;
        }

        this._onPaymentIntentCreated(response.data, done);
    }

    private _onPaymentIntentCreated = async (paymentIntentSecret: string, done: () => void) => {
        if (!this.props.stripe) {
            done();
            return;
        }

        const response = await this.props.stripe.handleCardPayment(paymentIntentSecret);

        if (response.error) {
            alert('Problem processing payment, please contact Medicheck.')
            done();
            return;
        }

        done();
        this.props.onPaymentCompleted(response.paymentIntent);
    }

    render() {

        const [base, tva, total] = this._calculateCheckTotal();
        return (
            <div style={this._style.form}>
                <div style={this._style.content}>
                    {/* CARD INPUTS */}
                    <div style={this._style.paymentForm}>
                        <StripeInputWrapperView label='cardNumber' component={CardNumberElementBetter} style={this._style.number} />
                        <StripeInputWrapperView label='cardExpiry' component={CardExpiryElementBetter} style={this._style.expiry} />
                        <StripeInputWrapperView label='cardCVC' component={CardCVCElementBetter} style={this._style.cvc} />
                    </div>

                    {/* PRICE BREAKDOWN */}
                    <div style={{ ...this._style.bubble, flexDirection: 'column' }}>
                        <div style={this._style.summaryWrapper}>
                            <TranslationView style={this._style.summaryText}>
                                orderSummary
                            </TranslationView>
                        </div>

                        <div style={this._style.priceWrapper}>
                            <TranslationView style={this._style.checkAmountText}>
                                totalBreakdown
                            </TranslationView>

                            <div style={{ display: 'flex', flex: 1, justifyContent: 'space-around', marginLeft: 15 }}>
                                <PriceBreakdownView label='htva' amount={base} />
                                <PriceBreakdownView label='tva' amount={tva} />
                                <PriceBreakdownView label='checkTotal' amount={total} style={{ fontWeight: FontWeight.REGULAR }} />
                            </div>
                        </div>
                    </div>

                    {/* TERMS AGREENMENT */}
                    <div style={this._style.bubble}>
                        <div style={{ marginRight: 15 }}>
                            <RadioButtonView onChange={this._onLicenseAgreementClick} />
                        </div>

                        <span>
                            <TranslationView style={this._style.termsAgreement}>
                                termsAgreementBefore
                            </TranslationView>
                            <TranslationView onClick={() => window.open(`https://medichecktemplates.blob.core.windows.net/legal/${this.props.routeProps.match.params.language.toUpperCase()}_General_Conditions_GDPR.pdf`)} style={this._style.termsAgreementLink}>
                                termsAgreementLink
                            </TranslationView>
                            <TranslationView style={this._style.termsAgreement}>
                                termsAgreementAfter
                            </TranslationView>
                        </span>
                    </div>
                </div>

                <PaginatedDialogFooterView numberOfPages={5} currentPage={5} onSubmit={this._onPaymentDetailsEntered} />
            </div>
        );
    }
}

class CardNumberElementBetter extends CardNumberElement {
    render() {
        return (
            <div style={{ width: '100%', height: '1.1875em', padding: '6px 0 7px' }}>
                <CardNumberElement style={style} />
            </div>
        )
    }
}

class CardExpiryElementBetter extends CardNumberElement {
    render() {
        return (
            <div style={{ width: '100%', height: '1.1875em', padding: '6px 0 7px' }}>
                <CardExpiryElement style={style} />
            </div>
        )
    }
}

class CardCVCElementBetter extends CardNumberElement {
    render() {
        return (
            <div style={{ width: '100%', height: '1.1875em', padding: '6px 0 7px' }}>
                <CardCVCElement style={style} />
            </div>
        )
    }
}

const style = {
    base: {
        fontSize: '16px',
        fontWeight: 300,
        color: '#424770',
        letterSpacing: '0.025em',
        '::placeholder': {
            color: '#aab7c4'
        }
    },
    invalid: {
        color: 'rgb(236, 84, 103)'
    }
};


export default injectStripe(PaymentFormView);